<script setup lang="ts">
import ModalDialogContent from '@/components/ModalDialogContent.vue'
import TextInput from '@/components/TextInput.vue'
import {MessageFeedbackRating} from '@/client/mentor/MessagesClient'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

defineProps<{
  id: string
  feedbackType: MessageFeedbackRating
  error?: string
}>()

const feedbackMessage = defineModel<string | undefined>({required: true})
</script>

<template>
  <ModalDialogContent :id="id">
    <div class="flex flex-col gap-4">
      <TextInput
        v-model="feedbackMessage"
        :placeholder="
          feedbackType === MessageFeedbackRating.THUMBS_DOWN
            ? t('assistant.chat.message.feedback.placeholderDown')
            : t('assistant.chat.message.feedback.placeholderUp')
        "
      />
      <span v-if="error" class="text-red text-sm">{{ error }}</span>
    </div>
  </ModalDialogContent>
</template>
